import { render } from "./Shipments.vue?vue&type=template&id=2726282f&scoped=true"
import script from "./Shipments.vue?vue&type=script&lang=js"
export * from "./Shipments.vue?vue&type=script&lang=js"

import "./Shipments.vue?vue&type=style&index=0&id=2726282f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2726282f"]])

export default __exports__